import { Box } from '@mui/material';
import { Trans } from '@lingui/react/macro';
import { useState, ChangeEvent } from 'react';
import { OperationResult } from 'urql';
import Button from '../Button';
import { TextFieldMultilineNonFormik } from '../Form/TextField';

export default function SheetPanelHelp({
  onClose,
  requestHelp,
}: {
  onClose: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  requestHelp: (message: string) => Promise<OperationResult<any>>;
}) {
  const [message, setMessage] = useState('');
  const onSubmit = async () => {
    if (message.trim().length > 0) {
      const result = await requestHelp(message);
      if (result.error) {
        throw new Error(result.error.message);
      }
      onClose();
    }
  };
  const onChange = (evt: ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(evt.target.value);
  };
  return (
    <Box display="flex" flexDirection="column">
      <TextFieldMultilineNonFormik
        id="SheetPanelHelp"
        label={<Trans context="Form label for help form">Get in touch</Trans>}
        sublabel={
          <Trans context="Form sublabel for a help form">
            What can we help you with?
          </Trans>
        }
        value={message}
        onChange={onChange}
        autoFocus
      />
      <Button sx={{ mt: 2, alignSelf: 'flex-end' }} onClick={onSubmit}>
        <Trans context="Button copy to submit a help request via email">
          Send email
        </Trans>
      </Button>
    </Box>
  );
}
